/**
 * 关于wx-jssdk配置
 */
export default {
  // state字段拼接字符
  STATE_JOIN_CHAR: '@',

  // 默认跳转的页面
  DEFAULT_NAVIGATE_PAGE: 'home_page',

  // 微信认证基地址
  WX_AUTH_BASE_URL: 'https://open.weixin.qq.com/connect/oauth2/authorize',

  // 微信认证地址后缀
  WX_AUTH_URL_SUFFIX: '#wechat_redirect',

  // 微信认证地址参数顺序
  WX_AUTH_PARAMS_ORDER: ['appid','redirect_uri','response_type','scope','component_appid','connect_redirect'],

  // 微信认证地址参数
  WX_AUTH_BASE_PARAMS: {
    appid: process.env.VUE_APP_WA_APP_ID,
    redirect_uri: encodeURIComponent(`${location.origin}${location.pathname}`),
    response_type: 'code',
    scope: 'snsapi_base',
    component_appid: process.env.VUE_APP_COMPONENT_APP_ID,
    connect_redirect: 1
  },
  // 微信分享分案
  WX_SHARE_PARAMS: {
    title: '迪卡侬',
    desc: '快来加入迪卡侬运动福利群'
  }
}
